module.exports = __webpack_public_path__ + "static/media/4931-05.2baf824e.png";